import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const OrderSuccessBanner = ({Message,OrderedItems,TotalAmount}) => {
   const [visible, setVisible] = useState(true);
     const navigate = useNavigate();
     const location = useLocation();
     useEffect(() => {
      console.log("ORDER ROUTES",Message,OrderedItems)
      const timeout = setTimeout(() => {setVisible(false)
          navigate(location.pathname, { replace: true, state: {} })
      }, 5000);
    
      return () => clearTimeout(timeout);
     }, []);
    if(!Message || !visible){
        return null;
    }
  return (
    <div 
      className="bg-green-50 border-l-4 border-green-500 text-green-800 p-5 mb-8 rounded-lg shadow-lg animate-fade-in" 
      role="alert"
    >
      <p className="font-bold text-xl mb-4">{Message}</p>
      
      {OrderedItems && OrderedItems.length > 0 && (
        <>
          <p className="text-sm text-green-700 mb-3">Here's a summary of your order:</p>
          <div className="space-y-4">
            {OrderedItems.map((item) => (
              <div 
                key={item.id} 
                className="flex items-center justify-between bg-white p-3 rounded-md border border-green-200 shadow-sm"
              >
                <div className="flex items-center gap-4">

                  <img 
                    src={item.image_url || 'https://via.placeholder.com/150'} 
                    alt={item.product_name}
                    className="w-16 h-16 object-cover rounded-md bg-gray-100"
                  />
                  <div>
                    <p className="font-semibold text-gray-800">{item.product_name}</p>
                    <p className="text-sm text-gray-500">Quantity: {item.quantity}</p>
                  </div>
                </div>
                <p className="font-bold text-lg text-gray-900">₹{item.amount}</p>
              </div>
            ))}
          </div>
          <div className="mt-6 border-t pt-4 text-right">
           <p className="text-lg font-bold text-green-900">
            Total Paid: ₹{TotalAmount.toFixed(2)}
           </p>
          </div>
        </>
      )}
    </div>
  )
}

export default OrderSuccessBanner
